const initialState = {
  mallElementType: 'all',
  searchData: {
    mallElementName: '',
    mallElementCode: '',
  },
  searchAttrs: {},

  clickedCategory: {},
  clickedLevel1Category: {},
  clickedLevel2Category: {},
  clickedLevel3Category: {},
  clickedLevel4Category: {},
  clickedLevel5Category: {},

  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,

  element: {},
  elements: [],

  level1Categories: [],
  level2Categories: [],
  level3Categories: [],
  level4Categories: [],
  level5Categories: [],
};

const resetState = {
  mallElementType: 'all',
  searchData: {
    mallElementName: '',
    mallElementCode: '',
  },
  searchAttrs: {},

  clickedCategory: {},
  clickedLevel1Category: {},
  clickedLevel2Category: {},
  clickedLevel3Category: {},
  clickedLevel4Category: {},
  clickedLevel5Category: {},

  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const mallSiteElementReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETMALLSITEELEMENTTYPE':
      return {
        ...state,
        mallElementType: action.payload,
      };
    case 'SETMALLSITEELEMENTSEARCHDATA':
      return {
        ...state,
        searchData: action.payload,
      };
    case 'SETMALLSITEELEMENTSEARCHATTS':
      return {
        ...state,
        searchAttrs: action.payload,
      };

    case 'SETMALLSITEELEMENTCLICKEDCATEGORY':
      return {
        ...state,
        clickedCategory: action.payload,
      };
    case 'SETMALLSITEELEMENTCLICKEDLEVEL1CATEGORY':
      return {
        ...state,
        clickedLevel1Category: action.payload,
      };
    case 'SETMALLSITEELEMENTCLICKEDLEVEL2CATEGORY':
      return {
        ...state,
        clickedLevel2Category: action.payload,
      };
    case 'SETMALLSITEELEMENTCLICKEDLEVEL3CATEGORY':
      return {
        ...state,
        clickedLevel3Category: action.payload,
      };
    case 'SETMALLSITEELEMENTCLICKEDLEVEL4CATEGORY':
      return {
        ...state,
        clickedLevel4Category: action.payload,
      };
    case 'SETMALLSITEELEMENTCLICKEDLEVEL5CATEGORY':
      return {
        ...state,
        clickedLevel5Category: action.payload,
      };

    case 'SETMALLSITEELEMENTPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETMALLSITEELEMENTTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETMALLSITEELEMENTISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };

    case 'SETMALLSITEELEMENTRESET':
      return {
        ...state,
        ...resetState,
      };

    case 'SELECTONEELEMENT':
      return {
        ...state,
        element: action.payload,
      };

    case 'SELECTELEMENTS':
      return {
        ...state,
        elements: action.payload,
      };

    case 'SETLEVEL1CATEGORIES':
      return {
        ...state,
        level1Categories: action.payload,
      };
    case 'SETLEVEL2CATEGORIES':
      return {
        ...state,
        level2Categories: action.payload,
      };
    case 'SETLEVEL3CATEGORIES':
      return {
        ...state,
        level3Categories: action.payload,
      };
    case 'SETLEVEL4CATEGORIES':
      return {
        ...state,
        level4Categories: action.payload,
      };
    case 'SETLEVEL5CATEGORIES':
      return {
        ...state,
        level5Categories: action.payload,
      };

    default:
      return state;
  }
};

export default mallSiteElementReducer;
